<app-complex-modal-template
    [canConfirm]="addDepositModalDataForm.valid"
    [stepNumber]="currentStep()"
    [title]="data.title | transloco"
    [(currentStep)]="currentStep"
    (onClickEvent)="onClickEvent($event)">
    <form [formGroup]="addDepositModalDataForm">
        @if (currentStep() === AddDepositStepEnum.FILE_IMPORT) {
            <app-drag-and-drop
                [acceptedFileExtensions]="acceptedDepositFileExtensions"
                [depositCount]="data.depositCount"
                [dragAndDropType]="DragAndDropTypeEnum.DEPOSIT"
                [maxBytesSize]="maxImportSizeOctet()"
                (newItemEvent)="getFile($event)" />

            <div class="px-4 mt-4 w-1/2">
                <app-button
                    customClass="!min-h-0 !gap-2 !px-0"
                    iconSize="xs"
                    [icon]="['fas', 'chevron-down']"
                    [iconPosition]="IconPosition.END"
                    [label]="'acceptedFormats.label' | transloco"
                    [matMenuTriggerFor]="acceptedDepositFileFormatsMenu"
                    [type]="ButtonType.UNDERLINE" />
            </div>

            <mat-menu
                #acceptedDepositFileFormatsMenu="matMenu"
                class="!max-w-none"
                yPosition="below">
                <div
                    class="min-w-80 p-3 text-sm text-custom-extra-dark-grey"
                    [attr.aria-label]="'acceptedFormats.label' | transloco"
                    (click)="$event.stopPropagation()">
                    <ul class="!m-0 !list-none !p-0 space-y-1">
                        @for (translationKey of acceptedDepositFileFormatTranslationKeys; track translationKey) {
                            <li>{{ translationKey | transloco }}</li>
                        }
                    </ul>
                    <p class="mt-2 text-xs text-custom-dark-grey">
                        {{ 'acceptedFormats.prjInformation' | transloco }}
                    </p>
                </div>
            </mat-menu>
        } @else {
            <div class="w-2/3">
                <app-input-text
                    [errors]="getNameErrors()"
                    [inputFormControl]="addDepositModalDataForm.controls.name"
                    [label]="'depositName' | transloco"
                    [placeholder]="'enterName' | transloco" />
            </div>
        }
    </form>

    <ng-container modalActions>
        @if (currentStep() === AddDepositStepEnum.FILE_IMPORT) {
            <app-button
                [disabled]="
                    !!addDepositModalDataForm.controls.file.getRawValue() || !!data.depositCount || !!data.standard
                "
                [icon]="['fas', 'plus']"
                [label]="'createEmptyDeposit' | transloco"
                [type]="ButtonType.PRIMARY"
                (onClick)="currentStep.set(AddDepositStepEnum.EMPTY_CREATION)" />
        }
    </ng-container>
</app-complex-modal-template>
